import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
    //  Accordion,
    Breadcrumb,
    Container,
    Divider,
    Dropdown,
    Embed,
    Grid,
    Icon,
    Image,
    Menu,
    Popup,
    Segment,
    Tab
} from 'semantic-ui-react';
import { HexColorPicker } from "react-colorful";
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { useAuth } from '../providers';


const Widgets = () => {
    //  const [activeIndex, setActiveIndex] = useState(-1);

    const [trackerColor, setTrackerColor] = useState('#FF0000');
    const [trackerDivider, setTrackerDivider] = useState('#CFBDA7');
    const [trackerFont, setTrackerFont] = useState('default');
    const [trackerBackground, setTrackerBackground] = useState('#1B1C1D');
    const [trackerGlow, setTrackerGlow] = useState('#000000');
    const [trackerTextGlow, setTrackerTextGlow] = useState(false);
    const [trackerAutoPan, setTrackerAutoPan] = useState(false);
    const [trackerHideEmpty, setTrackerHideEmpty] = useState(false);

    const { user } = useAuth();

    //  const [actionLogColor, setActionLogColor] = useState('#CFBDA7');
    //  const [actionLogBold, setActionLogBold] = useState('#FF0000');
    //  const [actionLogFont, setActionLogFont] = useState('default');
    //  const [actionLogBackground, setActionLogBackground] = useState('#1B1C1D');

    const fonts = [
        {
            key: 1,
            value: 'default',
            content: (
                <div style={{ fontFamily: 'default' }}>Isaac</div>
            ),
        },
        {
            key: 2,
            value: 'cursive',
            content: (
                <div style={{ fontFamily: 'cursive' }}>Cursive</div>
            ),
        },
        {
            key: 3,
            value: 'fantasy',
            content: (
                <div style={{ fontFamily: 'fantasy' }}>Fantasy</div>
            ),
        },
        {
            key: 4,
            value: 'monospace',
            content: (
                <div style={{ fontFamily: 'monospace' }}>Monospace</div>
            ),
        },
        {
            key: 5,
            value: 'sans-serif',
            content: (
                <div style={{ fontFamily: 'sans-serif' }}>Sans Serif</div>
            ),
        },
        {
            key: 6,
            value: 'serif',
            content: (
                <div style={{ fontFamily: 'serif' }}>Serif</div>
            ),
        },
    ]

    const panes = [
        {
            menuItem: 'Streamlabs OBS',
            render: () =>
                <Tab.Pane inverted>
                    <Image src={'/images/streamlabs_widget.gif'} size='medium' floated='right' />
                    <ul>
                        <li>Open Streamlabs OBS.</li>
                        <li>Click the '+' in Sources List to add a new source.</li>
                        <li>Choose '<strong>Browser Source</strong>' in the list of available sources. Click '<strong>Add Source</strong>'.</li>
                        <li>If you have existing sources, select '<strong>Add a new source instead</strong>' and click '<strong>Add Source</strong>'.</li>
                        <li>Paste the Live URL provided above in to the URL field, set the height to 80, and you can customize the width to your liking. Click '<strong>Done</strong>'</li>
                        <li>Arrange and scale the new Widget to your liking.</li>
                    </ul>
                </Tab.Pane>
        },
        {
            menuItem: 'OBS',
            render: () =>
                <Tab.Pane inverted>
                    <ul>
                        <li>Open OBS.</li>
                        <li>Click the '+' in Sources, and select '<strong>Browser</strong>' in the popup menu.</li>
                        <li>Select '<strong>Create new</strong>' and give the new source an appropriate name. Click '<strong>OK</strong>'.</li>
                        <li>Paste the Live URL provided above in to the URL field, set the height to 80, and you can customize the width to your liking. Click '<strong>OK</strong>'</li>
                        <li>Arrange and scale the new Widget to your liking.</li>
                    </ul>
                </Tab.Pane>
        },
        {
            menuItem: 'Twitch Studio',
            render: () =>
                <Tab.Pane inverted>
                    <ul>
                        <li>Open Twitch Studio.</li>
                        <li>In the '<strong>Edit Layout</strong>' mode, click '<strong>+</strong>' to add a new layer.</li>
                        <li>Choose '<strong>Embed Webpage</strong>' from the list.</li>
                        <li>Give the new layer an appropriate name.</li>
                        <li>When the new layer is added to your scene, you will find settings on the right side of the screen.</li>
                        <li>Paste the Live URL provided above, and click the '<strong>→</strong>' button.</li>
                        <li>Arrange and scale the new Widget to your liking.</li>
                    </ul>
                </Tab.Pane>
        },
        {
            menuItem: 'XSplit',
            render: () =>
                <Tab.Pane inverted>
                    <ul>
                        <li>Click '<strong>Add Source</strong>', and select '<strong>Webpage</strong>' from the list.</li>
                        <li>Paste the Live URL provided above, and press '<strong>OK</strong>'.</li>

                        <li>Click the '+' in Sources List to add a new source.</li>
                        <li>Choose '<strong>Browser Source</strong>' in the list of available sources. Click '<strong>Add Source</strong>'.</li>
                        <li>If you have existing sources, select '<strong>Add a new source instead</strong>' and click '<strong>Add Source</strong>'.</li>
                        <li>Paste the Live URL provided above in to the URL field, set the height to 80, and you can customize the width to your liking. Click '<strong>Done</strong>'</li>
                        <li>Arrange and scale the new Widget to your liking.</li>
                    </ul>
                </Tab.Pane>
        }
    ]
    /*
      const handleClick = (e, titleProps) => {
        const { index } = titleProps;
        setActiveIndex(activeIndex === index ? -1 : index);
      }
    */

    const BuildWidgetURL = (endpoint, preview) => {
        return 'https://' + window.location.hostname + '/' + endpoint + '/' + user["username"] +
            '?font=' + trackerFont +
            '&color=' + trackerColor.replace('#', '') +
            '&divider=' + trackerDivider.replace('#', '') +
            '&glow=' + trackerGlow.replace('#', '') +
            (trackerTextGlow ? '&text_glow=true' : '') +
            (trackerHideEmpty ? '&hide_empty=true' : '') +
            (trackerAutoPan ? '&auto_pan=true' : '') +
            (preview ? '&mode=preview' : '')
    }

    return (
        <Segment className='lobby' inverted>
            <Container text className='description'>
                <Breadcrumb size='huge'>
                    <Breadcrumb.Section link as={Link} to='/dashboard'>Dashboard</Breadcrumb.Section>
                    <Breadcrumb.Divider icon='right chevron' />
                    <Breadcrumb.Section active>Widgets</Breadcrumb.Section>
                </Breadcrumb>
                <Divider hidden />
                <p>
                    The following widgets allow you to add elements to OBS that interact with the mod. Simply add a new Browser Source element to your scene, and follow the instructions!
                </p>
                {/*
        <Accordion inverted fluid>
          <Accordion.Title
            active={activeIndex === 0}
            index={0}
            onClick={handleClick}
          >
            <Icon name='dropdown' />
            Item Tracker
          </Accordion.Title>
          <Accordion.Content active={activeIndex === 0}>
*/}
                <div>
                    <p>
                        Inspired by the popular <a href="https://github.com/Hyphen-ated/RebirthItemTracker">Item Tracker tool</a>, this widget will display which items were picked up on each floor. In addition, it will also display which items were given by chat through the mod.
                        You can customize the font, text color, and divider color below. The background color is adjustable in the preview for demonstration purposes only, to see how the other colors work, but the widget itself is transparent.
                    </p>
                    <p>
                        Features:
                    </p>
                    <ul>
                        <li>Restarts tracking on a new game run.</li>
                        <li>Tracks level progression in a run.</li>
                        <li>Displays when items are picked up in the game, on each floor.</li>
                        <li>Displays items that are received from the Twitching of Isaac mod, using a Twitch icon.</li>
                        <li>Displays a counter on items that have been received multiple times.</li>
                        <li>Auto scrolls to the right, in case there are more items and floors than available screen space.</li>
                    </ul>
                    <p>
                        Customization and Preview:<br />
                    </p>
                    <Menu attached='top' inverted style={{ backgroundColor: '#333' }}>
                        <Dropdown
                            item
                            icon='font'
                            simple
                            options={fonts}
                            onChange={(ev, { value }) => setTrackerFont(value)}
                        />
                        <Dropdown
                            item
                            icon={<Icon name='circle' style={{ color: trackerColor }} />}
                            simple
                            options={[
                                {
                                    key: 0,
                                    content: (
                                        <React.Fragment>
                                            <div style={{ 'color': '#fff' }}>Text Color:</div><br />
                                            <HexColorPicker color={trackerColor} onChange={setTrackerColor} />
                                        </React.Fragment>
                                    )
                                }
                            ]}
                        />
                        <Dropdown
                            item
                            icon={<Icon name='circle' style={{ color: trackerGlow }} />}
                            simple
                            options={[
                                {
                                    key: 0,
                                    content: (
                                        <React.Fragment>
                                            <div style={{ 'color': '#fff' }}>Glow Color:</div><br />
                                            <HexColorPicker color={trackerGlow} onChange={setTrackerGlow} />
                                        </React.Fragment>
                                    )
                                }
                            ]}
                        />
                        <Dropdown
                            item
                            icon={<Icon name='circle' style={{ color: trackerDivider }} />}
                            simple
                            options={[
                                {
                                    key: 0,
                                    content: (
                                        <React.Fragment>
                                            <div style={{ 'color': '#fff' }}>Divider Color:</div><br />
                                            <HexColorPicker color={trackerDivider} onChange={setTrackerDivider} />
                                        </React.Fragment>
                                    )
                                }
                            ]}
                        />
                        <Dropdown
                            item
                            icon={<Icon name='circle' style={{ color: trackerBackground }} />}
                            simple
                            options={[
                                {
                                    key: 0,
                                    content: (
                                        <React.Fragment>
                                            <div style={{ 'color': '#fff' }}>Background Color:</div><br />
                                            <HexColorPicker color={trackerBackground} onChange={setTrackerBackground} />
                                        </React.Fragment>
                                    )
                                }
                            ]}
                        />
                        <Popup
                            content="Apply glow color to text as well."
                            trigger={
                                <Menu.Item
                                    onClick={() => setTrackerTextGlow(current => !current)}
                                >
                                    Text Glow &nbsp; <Icon name={trackerTextGlow ? "check" : "x"} />
                                </Menu.Item>}
                        />
                        <Popup
                            content="Apply glow color to text as well."
                            trigger={
                                <Menu.Item
                                    onClick={() => setTrackerHideEmpty(current => !current)}
                                >
                                    Hide Empty Floors &nbsp; <Icon name={trackerHideEmpty ? "check" : "x"} />
                                </Menu.Item>}
                        />
                        <Popup
                            content="Apply glow color to text as well."
                            trigger={
                                <Menu.Item
                                    onClick={() => setTrackerAutoPan(current => !current)}
                                >
                                    Auto Pan &nbsp; <Icon name={trackerAutoPan ? "check" : "x"} />
                                </Menu.Item>}
                        />
                    </Menu>
                    <Segment attached style={{ height: '110px', backgroundColor: trackerBackground }} inverted>
                        <Embed
                            color='black'
                            url={BuildWidgetURL("inventory", true)}
                            purl={'/inventory/' + user["username"] + '?mode=preview&color=' + trackerColor.replace('#', '') + '&divider=' + trackerDivider.replace('#', '') + '&font=' + trackerFont}
                            autoplay={true}
                            active={true}
                            iframe={{
                                style: {
                                    height: '100px',
                                    backgroundColor: 'transparent',
                                },
                                frameBorder: 1,
                                height: '100px',
                                allowTransparancy: 'true'
                            }}
                            style={{
                                backgroundColor: 'transparent',
                                height: '100px'
                            }}
                        />
                    </Segment>
                    <Segment
                        attached='bottom'
                        inverted
                        style={{ backgroundColor: '#333' }}
                    >
                        <Grid>
                            <Grid.Row>
                                <Grid.Column width={2}>Live URL&nbsp;
                                    <CopyToClipboard
                                        text={BuildWidgetURL("inventory")}
                                    >
                                        <Icon name='copy' link />
                                    </CopyToClipboard>
                                </Grid.Column>
                                <Grid.Column width={14}>
                                    <strong>{BuildWidgetURL("inventory")}</strong>
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                    </Segment>
                    <p>
                        Instructions:
                    </p>
                    <Tab
                        menu={{ inverted: true, fluid: true, vertical: true }}
                        panes={panes}
                    />
                </div>
                {/*
          </Accordion.Content>

          <Accordion.Title
            active={activeIndex === 1}
            index={1}
            onClick={handleClick}
          >
            <Icon name='dropdown' />
            Action Log
          </Accordion.Title>
          <Accordion.Content active={activeIndex === 1}>
            <p>
              The Action Log is a text based version of the Item Tracker widget. It will display much of the same information, but will also call out the name of the chatter that may have given items during the run.
            </p>
            <p>
              Features:
            </p>
            <ul>
              <li>Restarts tracking on a new game run.</li>
              <li>Displays the name of the character currently being played as.</li>
              <li>Tracks level progression in a run.</li>
              <li>Displays when items are picked up in the game, on each floor.</li>
              <li>Displays items that are received from the Twitching of Isaac mod, and calls out the Twitch viewer by their username.</li>
              <li>Auto scrolls based on the available widget size.</li>
            </ul>
            <p>
              Customization and Preview:<br />
            </p>
            <Menu attached='top' inverted style={{ backgroundColor: '#333'}}>
              <Dropdown
                item
                icon='font'
                simple
                options={fonts}
                onChange={(ev, { value }) => setActionLogFont(value)}
              />
              <Dropdown
                item
                icon={<Icon name='circle' style={{color: actionLogColor}} />}
                simple
                options={[
                  {
                    key: 0,
                    content: (
                      <HexColorPicker color={actionLogColor} onChange={setActionLogColor} />
                    )
                  }
                ]}
              />
              <Dropdown
                item
                icon={<Icon name='circle' style={{color: actionLogBold}} />}
                simple
                options={[
                  {
                    key: 0,
                    content: (
                      <HexColorPicker color={actionLogBold} onChange={setActionLogBold} />
                    )
                  }
                ]}
              />
              <Dropdown
                item
                icon={<Icon name='circle' style={{color: actionLogBackground}} />}
                simple
                options={[
                  {
                    key: 0,
                    content: (
                      <HexColorPicker color={actionLogBackground} onChange={setActionLogBackground} />
                    )
                  }
                ]}
              />
            </Menu>
            <Segment attached style={{ height: '410px', backgroundColor: actionLogBackground}} inverted>
              <Embed
                color='black'
                url={'/actions/' + user["username"] + '?mode=preview&color=' + actionLogColor.replace('#', '') + '&highlight=' + actionLogBold.replace('#', '') + '&font=' + actionLogFont}
                autoplay={true}
                active={true}
                iframe={{
                  style: {
                    backgroundColor: 'transparent',
                  },
                  frameBorder: 1,
                  allowTransparancy: 'true'
                }}
                style={{
                  backgroundColor: 'transparent',
                }}
              />
            </Segment>
            <Segment
              attached='bottom'
              inverted
              style={{ backgroundColor: '#333' }}
            >
              <Grid>
                <Grid.Row>
                  <Grid.Column width={2}>Live URL&nbsp;
                    <CopyToClipboard
                      text={'https://' + window.location.hostname + '/actions/' + user["username"] + '?color=' + actionLogColor.replace('#', '') + '&highlight=' + actionLogBold.replace('#', '') + '&font=' + actionLogFont}
                    >
                      <Icon name='copy' link />
                    </CopyToClipboard>
                  </Grid.Column>
                  <Grid.Column width={14}>
                    <strong>https://{window.location.hostname + '/actions/' + user["username"] + '?color=' + actionLogColor.replace('#', '') + '&divider=' + actionLogBold.replace('#', '') + '&font=' + actionLogFont}</strong>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Segment>
            <p>
              Instructions:
            </p>
            <Tab
              menu={{ inverted: true, fluid: true, vertical: true }}
              panes={panes}
            />
          </Accordion.Content>
        </Accordion>
*/}
            </Container>
        </Segment>
    )
};

export default Widgets;
